import { SOLIDARITY_URLS } from './endpoints.constants';

const API_URL = process.env.API_URL;

const ENDPOINTS_SOLIDARITY = {
  get: {
    ongList: () => `${API_URL}/${SOLIDARITY_URLS.ROOT}/${SOLIDARITY_URLS.ONG_LIST}`,
    contributions: (employeeId) => `${API_URL}/${SOLIDARITY_URLS.ROOT}/${employeeId}/${SOLIDARITY_URLS.CONTRIBUTIONS}`,
  },
  post: {
    contributions: (employeeId) => `${API_URL}/${SOLIDARITY_URLS.ROOT}/${employeeId}/${SOLIDARITY_URLS.CONTRIBUTIONS}`,
  },
  put: {
    contributions: (employeeId) => `${API_URL}/${SOLIDARITY_URLS.ROOT}/${employeeId}/${SOLIDARITY_URLS.CONTRIBUTIONS}`,
  },
  delete: {
    contributions: (employeeId) => `${API_URL}/${SOLIDARITY_URLS.ROOT}/${employeeId}/${SOLIDARITY_URLS.CONTRIBUTIONS}`,
  },
};

export {
  ENDPOINTS_SOLIDARITY
};



// WEBPACK FOOTER //
// ./client/app/common/endpoints/solidarity.endpoints.js